import features from "../features.json";

export function isHasFeature(key: keyof typeof features) {
  return features[key];
}
